module.exports = __webpack_public_path__ + "media/images/undraw/matching/profile-3080e3ff9dc88e722ec06534acdc8a5a.png";